import { getMenuByUser } from '@/api/api'

const state = {
  permissions: [],    // 所有权限列表 (包含 menuType=2 的按钮权限)
  btnPermissions: []  // 仅按钮权限列表 (menuType=2)
}

const getters = {
  getPermissions: state => state.permissions,
  getBtnPermissions: state => state.btnPermissions
}

const mutations = {
  SET_PERMISSIONS(state, permissions) {
    state.permissions = permissions || []
    // 提取按钮权限 (menuType=2)
    state.btnPermissions = permissions?.filter(item => item.menuType === 2) || []
  },
  CLEAR_PERMISSIONS(state) {
    state.permissions = []
    state.btnPermissions = []
  }
}

const actions = {
  /**
   * 获取用户菜单和权限
   */
  async getPermissions({ commit }) {
    try {
      const res = await getMenuByUser()
      if (res.code === 1000) {
        commit('SET_PERMISSIONS', res.data)
        return res.data
      } else {
        console.error('获取权限失败:', res.message)
        commit('CLEAR_PERMISSIONS')
        return []
      }
    } catch (error) {
      console.error('获取权限异常:', error)
      commit('CLEAR_PERMISSIONS')
      return []
    }
  },

  /**
   * 清空权限
   */
  clearPermissions({ commit }) {
    commit('CLEAR_PERMISSIONS')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
